import MelodyCarousel from 'components/common/MelodyCarousel';
import MelodyCardCategory from 'components/common/melodyCard/MelodyCardCategory';

import css from 'styles/components/landing/melodyCategory.scss';

const stylesWithNoBackground = ['bottomAlignedWithNoBackground'];
const stylesWithBottomAligned = ['bottomAlignedWithNoBackground'];

export const MelodyCategory = ({ slotName, slotDetails, onLandingComponentClick, shouldLazyLoad }) => {
  const { heading, style, categories, monetateId } = slotDetails;
  const noBackground = stylesWithNoBackground.includes(style);
  const bottomAligned = stylesWithBottomAligned.includes(style);

  if (categories?.length) {
    if (style === 'featureNav') {
      const altCss = {
        featureCss: css.featureCss,
        imgCss: css.imgCss
      };

      return (
        <div className={css.wrap} data-slot-id={slotName} data-monetate-id={monetateId}>
          <div className={css.items}>
            {categories.slice(0, 4).map((category, i) => {
              const { gae } = category;
              return <MelodyCardCategory
                cardData={category}
                onLandingComponentClick={onLandingComponentClick}
                key={`${gae}-${i}`}
                eventLabel="melodyCategoryFeatureNav"
                melodyCardTestId="melodyCategoryFeatureNav"
                shouldLazyLoad={shouldLazyLoad}
                altCss={altCss} />;
            })}
          </div>
        </div>);
    }
    return (
      <div className={css.wrap} data-slot-id={slotName} data-monetate-id={monetateId}>
        {heading && (
          <h2 className={css.heading}>
            {heading}
          </h2>
        )}
        <MelodyCarousel>
          {categories.map((category, i) => {
            const { gae } = category;
            return <MelodyCardCategory
              cardData={category}
              onLandingComponentClick={onLandingComponentClick}
              key={`${gae}-${i}`}
              eventLabel="melodyCategory"
              melodyCardTestId="melodyCategory"
              shouldLazyLoad={shouldLazyLoad}
              bottomAligned={bottomAligned}
              noBackground={noBackground}/>;
          })}
        </MelodyCarousel>
      </div>
    );
  } else {
    return false;
  }
};

export default MelodyCategory;
